import {extendTheme} from "@chakra-ui/react";

const theme = extendTheme({
    colors: {
        dark: '#080411',
        purple: {
            500: "#5834A8",
            400: "#7E5EF7",
            300: "rgba(111, 65, 210, 0.25)",
            200: "rgba(111, 65, 210, 0.25)",
        },
        success: {
            300: "#103923",
            200: "#2FA766",
            100: "#C5EFD8",
        },
        warning: {
            300: "#7B5D24",
            200: "#F6BA47",
            100: "#FCEAC8",
        },
        error: {
            300: "#5A1C1E",
            200: "#E2464A",
            100: "#F9DADB",
        },
        green: {
            500: "#47BB75",
            selected: "#1D673F",
            normal: "#2FA766",
            hover: "#268752",
        },
        red: {
            selected: "#882A2C",
            normal: "#E2464A",
            hover: "#B5383B",
        },
        neutral: {
            1100: "#18191D",
            1000: "#1C1E24",
            900: "#23262F",
            800: "#353945",
            700: "#3F4352",
            600: "#777E90",
            500: "#B1B5C3",
            400: "#D6D8E0",
            300: "#E6E8EC",
            200: "#F4F5F6",
            100: "#FCFCFD",
        },
        pink: "#EE4E68",
        blue: "#466FF7",
        orange: "#F5693D",
        yellow: "#F7CB46",
        cyan: "#CBDDFF",
        gradient: {
            primary: {value: "linear-gradient(180deg, rgba(88, 52, 168, 0.7) 0%, rgba(255, 255, 255, 0) 100%)"},
            secondary: {value: "linear-gradient(90deg, #B092FF 0%, #999999 100%)"},
            radial: {value: "radial-gradient(50% 50% at 50% 50%, rgba(94, 148, 255, 0.24) 0%, rgba(49, 94, 255, 0) 100%)"},
        },
    },
    styles: {
        global: {
            "html, body": {
                margin: 0,
                padding: 0,
            },
            ".main-container": {
                maxW: "1280px",
                margin: "auto",
            },
            "p, h1, h2, h3, h4": {
              lineHeight: '120%',
            },
            "::-webkit-scrollbar": {
                width: "4px",
                height: "8px",
            },
            "::-webkit-scrollbar-track": {
                background: "transparent",
            },
            "::-webkit-scrollbar-thumb": {
                background: "#5834A8",
                borderRadius: "8px",
            },
            "::-webkit-scrollbar-thumb:hover": {
                background: "#4a2b91",
            },
        },
    },
    sizes: {
        sm: "480px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        cs:'1400px',
        "2xl": "1440px",
        "2.5xl": "1872px",
        "3xl": "1920px",
    },
    fontSizes: {
        heading: {
            xs: "10px",
            sm: "12px",
            md: "14px",
            lg: "16px",
            xl: "18px",
            "2xl": "20px",
            "3xl": "24px",
            "4xl": "26px",
            "5xl": "28px",
        },
        body: {
            xs: "12px",
            sm: "14px",
            md: "16px",
            lg: "18px",
            xl: "20px",
        },
        display: {
            sm: "32px",
            md: "40px",
            lg: "48px",
            xl: "64px",
        },
    },
    breakpoints: {
        base: "0",
        xs: "400",
        sm: "480px",
        "2sm": "500px",
        md: "768px",
        xm: "991px",
        lg: "1200px",
        xl: "1350px",
        cs: "1400px",
        "2xl": "1536px",
        "3xl": "1920px",
    },
    fonts: {
        // body: "IBM Plex Sans, sans-serif",
        heading: "IBM Plex Sans, sans-serif",
    },
    durations: {
        fast: "100ms",
    },
});

export default theme;
